import { Navigate } from "react-router-dom"

import { provideComponent, useData } from "scrivito"
import { NOT_FOUND } from "shared/constants/permalinks"

import { useNavigateToPermalink } from "features/navigation/model/useNavigateToPermalink"
import { ProjectPageLoader } from "pages/project-page/ProjectPageLoader"
import { SharedProjectPageConnector } from "pages/project-page/shared-project-page/SharedProjectPageConnector"

import { SharedProjectPageObjClass } from "./SharedProjectPageObjClass"

provideComponent(
  SharedProjectPageObjClass,
  ({ page }) => {
    const data = useData()
    const projectShareID = data.isDataItem()
      ? (data.dataItem()?.get("shareId") as string)
      : null

    const { href } = useNavigateToPermalink(NOT_FOUND)

    if (!projectShareID) {
      return <Navigate to={href} />
    }

    return (
      <SharedProjectPageConnector projectShareID={projectShareID} page={page} />
    )
  },
  {
    loading: () => <ProjectPageLoader />
  }
)
